module.exports = __webpack_public_path__ + "img/card_220250565.7076196f.jpg";